import { useEffect, useState } from 'react';

export const use100vh = (): number | null => {
  const [height, setHeight] = useState<number | null>(measureHeight);

  useEffect(() => {
    function setMeasuredHeight() {
      const measuredHeight = measureHeight();
      setHeight(measuredHeight);
    }

    window.addEventListener('resize', setMeasuredHeight);
    return () => window.removeEventListener('resize', setMeasuredHeight);
  }, []);

  return height;
};

export const measureHeight = (): number | null => {
  const isClient =
    typeof window !== 'undefined' && typeof document !== 'undefined';
  if (!isClient) return null;
  return window.innerHeight;
};
